/**
 * @Description 图例
 */
import { FC, Fragment, useEffect, useMemo, useRef, useState } from 'react';
// import { useMethods } from '@lhb/hook';
import { Divider } from 'antd';
import {
  targetShops,
  targetMallShops,
  targetSurrounding,
} from '../../ts-config';
import cs from 'classnames';
import styles from './index.module.less';
import IconFont from '@/common/components/IconFont';
import LegendItem from './LegendItem';
// import { useBigdataFn } from '@/common/utils/bigdata';

const Legend: FC<any> = ({
  isMallType,
  legendData,
  mainHeight,
  detail,
  storeChecked,
  surroundingChecked,
  setFamousBrandData,
  setCompetitorsData,
  setCommonStoreData,
  setCommonRimData,
  tenantId,
  drawerData,
  isOpenHeatMap
}) => {
  // const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [legendIconActive, setLegendIconActive] = useState(false);
  const [legendLayerActive, setLegendLayerActive] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const containerRef = useRef<any>(null);

  const legendDataGroup = useMemo(() => {
    // 经营门店
    const targetShopEnum = isMallType ? targetMallShops : targetShops;
    const shopGroup = legendData?.filter((item: any) => targetShopEnum.includes(item.key));
    // 周边配套
    const surroundingGroup = legendData?.filter((item: any) => targetSurrounding.includes(item.key));
    return [
      [...shopGroup],
      [...surroundingGroup]
    ];
  }, [legendData, isMallType]);

  const maxHeight = useMemo(() => {
    return mainHeight - 180;
  }, [mainHeight]);

  useEffect(() => {
    if (legendIconActive || legendLayerActive) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [legendIconActive, legendLayerActive]);

  useEffect(() => {
    containerRef.current.scrollTop = 0;
  }, [legendIconActive]);

  return (
    <>
      <div
        className={styles.legendCon}
        onMouseEnter={() => {
          setLegendIconActive(true);
          // bigdataFn('b72a6315-116f-4eae-a34b-161c78e75cfa', '详情-地图-移入图例', '点击了详情-地图-移入图例', { op_block: '开店区域-详情页', op_event: `${detail?.cityName}-${detail.areaName}`, });
        }}
        onMouseLeave={() => setLegendIconActive(false)}
      >
        <div>
          <IconFont iconHref='iconic_zuzhi' className='fs-20 c-222'/>
        </div>
        <div className='c-222 fs-12 font-weight-500'>图例</div>
      </div>
      {/* 图例列表 */}
      <div
        className={cs(styles.legendListCon, isActive ? styles.isActive : '')}
        onMouseEnter={() => {
          setLegendLayerActive(true);
        }}
        onMouseLeave={() => setLegendLayerActive(false)}
        style={{
          maxHeight: `${maxHeight}px`
        }}
        ref={containerRef}
      >
        <div className='c-333 fs-14 font-weight-500 mb-12'>
          图例
        </div>
        {
          legendDataGroup?.map((item: any, index: number) => <Fragment key={index}>
            {
              item?.map((targetItem: any, idx: number) => <div key={idx} className='mt-8'>
                <LegendItem
                  item={targetItem}
                  detail={detail}
                  legendData={legendData}
                  storeChecked={storeChecked}
                  surroundingChecked={surroundingChecked}
                  setFamousBrandData={setFamousBrandData}
                  setCompetitorsData={setCompetitorsData}
                  setCommonStoreData={setCommonStoreData}
                  setCommonRimData={setCommonRimData}
                  tenantId={tenantId}
                  drawerData={drawerData}
                  isOpenHeatMap={isOpenHeatMap}
                />
              </div>)
            }
            {
              index < legendDataGroup?.length - 1 ? <Divider
                style={{
                  marginTop: 8,
                  marginBottom: 8,
                  background: '#eee'
                }}
              /> : <></>
            }
          </Fragment>)
        }
      </div>
    </>
  );
};

export default Legend;
